// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__vBcSu","title":"styles_title__s4L61","description":"styles_description__Ips50"};